import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { recruiterEnv } from '@/config/env';

/**
 * Human-readable PT-BR label per top-level route segment. Keys are the first
 * path segment (e.g. `/vagas/123` → `vagas`). A segment without an entry
 * falls back to the bare brand title.
 */
const SECTION_LABELS: Record<string, string> = {
  vagas: 'Vagas',
  programas: 'Programas',
  companies: 'Empresas',
  formularios: 'Formulários',
  login: 'Entrar',
};

/**
 * DEV-258 — páginas abertas por quem não é da Eureca (formulário da pessoa
 * gestora): título próprio, sem o nome interno do app.
 */
const PUBLIC_TITLES: Record<string, string> = {
  'descricao-vaga': 'Descrição de vaga · Eureca',
};

function sectionLabelForPath(pathname: string): string | null {
  const segment = pathname.split('/').filter(Boolean)[0];
  if (!segment) return 'Início';
  return SECTION_LABELS[segment] ?? null;
}

/**
 * Keeps `document.title` in sync with the current route on every navigation:
 * `"<section> · <App>"`, or just the app name on unmapped paths.
 */
export function useDocumentTitle(): void {
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  useEffect(() => {
    const publicTitle = PUBLIC_TITLES[pathname.split('/').filter(Boolean)[0] ?? ''];
    if (publicTitle) {
      document.title = publicTitle;
      return;
    }
    const label = sectionLabelForPath(pathname);
    document.title = label
      ? `${label} · ${recruiterEnv.appDisplayName}`
      : recruiterEnv.appDisplayName;
  }, [pathname]);
}
